import { GroupOverviewComponent } from './group-overview/group-overview.component';

export const GroupRoutes = [
  {
    path: '',
    component: GroupOverviewComponent,
  },
  {
    path: ':id',
    component: GroupOverviewComponent,
  },
];
